module.exports = __webpack_public_path__ + "static/media/facebook.a635a2cb.svg";